import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
export function Hero() {
  const benefits = ['Recetas listas en pocos minutos', 'Ingredientes fáciles de conseguir', 'Diseñadas para objetivos específicos'];
  return <section className="relative pt-[190px] pb-20 sm:pt-[170px] lg:pt-40 lg:pb-32 overflow-hidden bg-cream" data-id="element-536">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-537">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-538">
          {/* Left Column - Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-539">
            <h1 className="text-5xl sm:text-6xl lg:text-[64px] font-extrabold leading-[1.05] text-ink mb-6 tracking-tight" data-id="element-540">
              Comer saludable nunca fue tan fácil.
            </h1>

            <p className="text-lg sm:text-xl text-ink-light mb-8 leading-relaxed font-light" data-id="element-541">
              Más de 360 recetas desarrolladas para ayudarte a mejorar tu
              alimentación según tus objetivos y necesidades, utilizando
              ingredientes simples, económicos y fáciles de conseguir.
            </p>

            <div className="flex items-center gap-4 mb-8 bg-white/50 inline-flex px-4 py-2 rounded-full border border-ink/5" data-id="element-542">
              <div className="flex gap-1 text-combo-green" data-id="element-543">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-544" />)}
              </div>
              <span className="text-sm font-semibold text-ink" data-id="element-545">4.9/5</span>
              <span className="text-sm text-ink-light hidden sm:inline" data-id="element-546">
                Miles de personas ya transformaron su alimentación
              </span>
            </div>

            <div className="space-y-3 mb-10" data-id="element-547">
              {benefits.map((benefit, i) => <div key={i} className="flex items-center gap-3" data-id="element-548">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-combo-green/10 flex items-center justify-center" data-id="element-549">
                    <Check className="w-4 h-4 text-combo-green" data-id="element-550" />
                  </div>
                  <span className="text-base font-medium text-ink" data-id="element-551">
                    {benefit}
                  </span>
                </div>)}
            </div>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-552">
              <a href="#kits" className="inline-flex w-full sm:w-auto items-center justify-center bg-combo-green text-white px-10 py-5 rounded-full font-bold text-lg hover:bg-combo-green/90 transition-all shadow-premium hover:shadow-premium-hover hover:-translate-y-1" data-id="element-553">
                QUIERO EMPEZAR HOY
              </a>
            </div>
          </motion.div>

          {/* Right Column - Premium Composition */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative lg:h-full flex items-center justify-center" data-id="element-554">
            <div className="absolute inset-0 bg-white rounded-[3rem] blur-3xl opacity-60 scale-110" data-id="element-555"></div>
            <div className="relative z-10 w-full max-w-lg" data-id="element-556">
              <div className="relative w-full aspect-square rounded-[2.5rem] bg-white shadow-premium border border-ink/5 p-8 flex items-center justify-center overflow-hidden" data-id="element-557">
                <img src="https://cdn.magicpatterns.com/uploads/txUCndoAYuPUx4sJe9oq2s/ChatGPT_Image_27_may_2026,_01_57_49_p.m..png" alt="Pack Completo" className="w-full h-auto object-contain relative z-20 drop-shadow-2xl" data-id="element-558" />

                {/* Floating Elements */}
                <motion.div animate={{
                y: [-10, 10, -10]
              }} transition={{
                duration: 4,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="absolute top-10 left-10 w-20 h-20 bg-white rounded-2xl shadow-premium border border-ink/5 p-2 z-30" data-id="element-559">
                  <img src="https://images.unsplash.com/photo-1490645935967-10de6ba17061?auto=format&fit=crop&q=80&w=200&h=200" alt="Receta" className="w-full h-full object-cover rounded-xl" data-id="element-560" />
                </motion.div>

                <motion.div animate={{
                y: [10, -10, 10]
              }} transition={{
                duration: 5,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="absolute bottom-10 right-10 w-24 h-24 bg-white rounded-2xl shadow-premium border border-ink/5 p-2 z-30" data-id="element-561">
                  <img src="https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&q=80&w=200&h=200" alt="Receta" className="w-full h-full object-cover rounded-xl" data-id="element-562" />
                </motion.div>

                <div className="absolute top-1/4 right-1/4 w-32 h-32 bg-combo-green/10 rounded-full blur-2xl" data-id="element-563"></div>
                <div className="absolute bottom-1/4 left-1/4 w-40 h-40 bg-gold/20 rounded-full blur-3xl" data-id="element-564"></div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}